import {
  createApiFactory,
  createComponentExtension,
  createPlugin,
  discoveryApiRef,
} from '@backstage/core-plugin-api';

import { ldapApiRef, LdapClient } from './api';
import { rootRouteRef } from './routes';

export const ldapPlugin = createPlugin({
  id: 'ldap',
  apis: [
    createApiFactory({
      api: ldapApiRef,
      deps: { discoveryApi: discoveryApiRef },
      factory: ({ discoveryApi }) => LdapClient.fromConfig(discoveryApi),
    }),
  ],
  routes: {
    root: rootRouteRef,
  },
});

export const EntityUserAdGroupsCard = ldapPlugin.provide(
  createComponentExtension({
    name: 'EntityUserAdGroupsCard',
    component: {
      lazy: () => import('./components/AdGroupsCard').then(m => m.AdGroupsCard),
    },
  }),
);

export const UserSearchField = ldapPlugin.provide(
  createComponentExtension({
    name: 'UserSearchField',
    component: {
      lazy: () =>
        import('./components/UserSearchField').then(m => m.UserSearchField),
    },
  }),
);
